import angular from 'angular';
import f from 'odata-filter-builder';
import {
  USER_INGREDIENT_ADDED,
  USER_INGREDIENT_EDITED,
  USER_INGREDIENT_DELETED,
  USER_INGREDIENT_DELETE_CONFIRMATION
} from 'common/messages';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './user-ingredients.html';

export default {
  templateUrl,
  bindings: {
    flex: '@',
    layout: '@',
    ingredients: '<',
    query: '<'
  },
  controller: class UserIngredientsComponent {
    constructor($mdDialog, $scope, $state, ToastService, UserIngredientsService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        $state,
        ToastService,
        UserIngredientsService
      });
    }

    $onInit() {
      this.columns = [{
        FieldName: 'UserIngredientName',
        DisplayName: 'Ingredient Name'
      }, {
        FieldName: 'ProductCount',
        DisplayName: 'Product Count'
      }];

      this.selectedIngredients = [];
    }

    onSearchTextChanged({ searchText }) {
      this.selectedIngredients = [];
      this.searchText = searchText;
      this.query = {
        ...this.query,
        filter: f().contains('UserIngredientName', searchText)
      };

      this.refreshResults();
    }

    onQueryChanged({ query }) {
      this.selectedIngredients = [];
      this.query = query;
      this.refreshResults();
    }

    refreshResults() {
      this.promise = this.UserIngredientsService.search(this.query);
      this.promise.then((r) => {
        this.ingredients = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }

    canDeleteIngredients(ingredients) {
      if (!(ingredients && ingredients.length)) {
        return false;
      }

      return true; // !ingredients.some(x => x.ProductCount > 0);
    }

    ingredientAdd() {
      const scope = angular.extend(this.$scope.$new(true), {
        ingredientChanged: $event => this.onIngredientAdded($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <user-ingredient-form
                dialog-title="Add New User Ingredient"
                submit-title="Add User Ingredient"
                ingredient-changed="ingredientChanged($event)">
              </user-ingredient-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onIngredientAdded({ ingredient }) {
      this.UserIngredientsService.add(ingredient)
        .then(() => {
          this.$mdDialog.hide();
          this.refreshResults();
          this.ToastService.showSuccess(USER_INGREDIENT_ADDED);
        }).catch(error => this.ToastService.showError(error));
    }

    ingredientEdit(ingredient) {
      const scope = angular.extend(this.$scope.$new(true), {
        ingredientChanged: $event => this.onIngredientEdited($event),
        ingredient: angular.copy(ingredient)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <user-ingredient-form
                ingredient="ingredient"
                dialog-title="Edit User Ingredient"
                submit-title="Save Changes"
                ingredient-changed="ingredientChanged($event)">
              </user-ingredient-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    ingredientDelete(ingredients) {
      const confirm = this.$mdDialog.confirm()
        .title('Are you sure?')
        .textContent(USER_INGREDIENT_DELETE_CONFIRMATION)
        .ok('Delete')
        .cancel('Cancel');

      this.$mdDialog.show(confirm).then(() => {
        const promises = [];
        for (let i = ingredients.length - 1; i >= 0; i -= 1) {
          promises.push(this.UserIngredientsService.delete(ingredients[i].UserIngredientId));
        }

        Promise.all(promises).then(() => {
          this.ToastService.showSuccess(USER_INGREDIENT_DELETED);
          this.selectedIngredients = [];
          this.refreshResults();
        }).catch((error) => {
          if (error.statusText === 'Bad Request'
            && error.data
            && error.data.Message) {
            this.ToastService.showError(error, error.data.Message);
          } else {
            this.ToastService.showError(error);
          }
        });
      });
    }

    onIngredientEdited({ ingredient }) {
      this.UserIngredientsService.update(ingredient)
        .then(() => {
          this.$mdDialog.hide();
          this.selectedIngredients = [];
          this.refreshResults();
          this.ToastService.showSuccess(USER_INGREDIENT_EDITED);
        }).catch(error => this.ToastService.showError(error));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredients.component.js